import Rules from 'SearchBuilder/components/Rules'
import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import store from 'Shared/store'
import { Provider } from 'react-redux'
import { useDispatch } from 'react-redux'


export default function RulesFilter({ value, onChange }) {
  return null ;

  return <Provider store={store}>
    <RulesFilterInner value={value} onChange={onChange} />
  </Provider>
}

const defaultRules = [
  { id: 'root', type: 'group', operator: 'AND', ruleIds: [] },
  { id: 'exclude-root', type: 'group', operator: 'OR', not: true, ruleIds: [] },
]

function RulesFilterInner({ value, onChange }) {
  const dispatch = useDispatch()
  const act = useAct()
  const [open, setOpen] = useState(false)
  const rules = useSel(s => _.values(s.rules.entities), _.isEqual)

  useEffect(() => {
    if (value) {
      // dispatch({
      //   type: 'rules/setAll',
      //   payload: value
      // })
    } else if (!rules || rules.length === 0) {

      dispatch({ type: 'rules/setAll', payload: defaultRules })
    }
  }, [value, rules])

  useEffect(() => {
    console.log('Rules changed:', JSON.stringify(rules))
    setTimeout(() => onChange(rules), 1000)
  }, [JSON.stringify(rules)])

  useEffect(() => {
    act.search.loadAvailableFilters()
  }, [])

  const handleChange = (newValue) => {
    console.log('New value:', newValue)
    onChange(newValue)
  }

  function clearFilter() {
    dispatch({ type: 'rules/setAll', payload: defaultRules })
  }

  return (
    <div className="rules-filter">
      <BackdropModal
        title="Edit audience rules"
        open={open}
        onCancel={() => setOpen(false)}
        key="rules-filter"
      >
        <Rules value={value} onChange={handleChange} hideHelp />
      </BackdropModal>
      <div className='fake-select-wrapper'>
        <div className='fake-select' onClick={() => setOpen(true)}>
          <span>{ value ? "Edit rules" : "Add Rules" }</span>
          <svg className='dropdown-icon' viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </div>
        {value && (
          <button className='clear-filter' onClick={clearFilter} title="Clear filter">
            Clear
          </button>
        )}
      </div>
    </div>
  )
}
